import sync from "@/database/sync";
import dates from "@/database/dates";
import { _ } from "vue-underscore";

export default {
  data() {
    return {
      arrayChunkSize: 5,
    };
  },
  async created() {
    if (!process.env.VUE_APP_IS_WEB) {
      // sync engine CRON
      this.$crontab.addJob({
        name: "syncEngine",
        interval: {
          seconds: "/30",
        },
        job: this.syncEngineFunction,
        sync: 0, // Whether to synchronize and execute when multiple jobs are registered
        condition: () => {
          return this.syncingConditionsPass;
        },
      });
      // First call ..
      setTimeout(() => {
        this.syncEngineFunction();
      }, 3000);
    }
  },
  computed: {
    showSyncingIndicatorInHeader() {
      return this.isDesktop && this.networkStatus && this.isAuthenticated;
    },
    isAuthenticatedForSyncing() {
      return this.$store.getters["auth/isAuthenticatedForSyncing"];
    },
    syncingConditionsPass() {
      return (
        this.isDesktop &&
        !this.showSyncLoading &&
        this.networkStatus &&
        this.isAuthenticated &&
        this.isAuthenticatedForSyncing
      );
    },
  },
  methods: {
    async syncEngineFunction() {
      try {
        // autheticate for the web
        if (!this.isAuthenticatedForSyncing) {
          let loginData = {
            username: this.$store.state.auth.username,
            password: this.$store.state.auth.userPassword,
          };
          await this.$store.dispatch("auth/login", loginData);
        }

        // check if conditions pass
        if (!this.syncingConditionsPass) {
          console.warn("Conditions for syncing to run don't pass");
          this.syncingFailed();
          return;
        }

        this.$store.state.showSyncLoading = true;

        var webChanges = [];
        var desktopChanges = [];
        var conflicts = {};
        var conflictsKeepWeb = [];
        var conflictsKeepDesktop = [];

        // get all changes from web (by appId)
        webChanges = await sync.getWebChanges(this.appId);

        // get all changed from desktop
        desktopChanges = await sync.getDesktopChanges();

        // !!!: TODO: find a way to avoid table header duplicates ..

        // group changes by uuid
        var changesGroupedByUuid = _.groupBy(webChanges.concat(desktopChanges), change => {
          return change.row_uuid;
        });
        // get conflicts separately & remove them from the other two arrays (webChanges, desktopChanges)
        for (let [rowUuid, groupedChange] of Object.entries(changesGroupedByUuid)) {
          if (groupedChange.length > 1) {
            webChanges = _.reject(webChanges, change => {
              return change.row_uuid == rowUuid;
            });
            desktopChanges = _.reject(desktopChanges, change => {
              return change.row_uuid == rowUuid;
            });
          } else {
            delete changesGroupedByUuid[rowUuid];
          }
        }
        conflicts = changesGroupedByUuid;

        // set which changes to take into account (web or desktop)
        for (let [rowUuid, conflict] of Object.entries(conflicts)) {
          let indexOfTheChangeTakenIntoAccount = null;
          const datetime0 = dates.format_date_to_utc(conflict[0].datetime);
          const datetime1 = dates.format_date_to_utc(conflict[1].datetime);

          if (datetime0 > datetime1) {
            indexOfTheChangeTakenIntoAccount = 0;
          } else if (datetime0 < datetime1) {
            indexOfTheChangeTakenIntoAccount = 1;
          } else if (datetime0 == datetime1) {
            if (conflict[0].app_id) indexOfTheChangeTakenIntoAccount = 0;
            else indexOfTheChangeTakenIntoAccount = 1;
          }

          if (conflict[indexOfTheChangeTakenIntoAccount].app_id) {
            conflictsKeepWeb.push(conflict[indexOfTheChangeTakenIntoAccount]);
          } else {
            conflictsKeepDesktop.push(conflict[indexOfTheChangeTakenIntoAccount]);
          }
        }

        console.log("SYNC webChanges", webChanges);
        console.log("SYNC desktopChanges", desktopChanges);
        console.log("SYNC conflicts", conflicts);
        console.log("SYNC conflictsKeepWeb", conflictsKeepWeb);
        console.log("SYNC conflictsKeepDesktop", conflictsKeepDesktop);

        // 1. conflicts
        // get objects that need to be synced from web (based on table name & uuid)
        // update in local db
        // get objects that need to be synced from desktop (based on table name & uuid)
        // update in remote db + add changes in remote sync table for other app ids (done automatically .. eventually, ignore this appId) ???: ..
        // at the end remove rows from desktop sync table for this row_uuid & from remote sync table for this row_uuid + app_id

        // split array into chunks
        conflictsKeepWeb = sync.chunkArray(conflictsKeepWeb, this.arrayChunkSize);

        var uuidsOfConflictsSyncedFromWeb = [];
        for (const chunkOfConflictsKeepWeb of conflictsKeepWeb) {
          let conflictsToSyncFromWeb = [];
          let responseUuidsOfConflictsSyncedFromWeb = [];

          conflictsToSyncFromWeb = await sync.getObjectsThatNeedToBeSyncedFromWeb(
            chunkOfConflictsKeepWeb
          );

          if (conflictsToSyncFromWeb)
            responseUuidsOfConflictsSyncedFromWeb = await sync.syncValuesInDesktopDB(
              conflictsToSyncFromWeb
            );
          if (responseUuidsOfConflictsSyncedFromWeb)
            uuidsOfConflictsSyncedFromWeb = uuidsOfConflictsSyncedFromWeb.concat(
              responseUuidsOfConflictsSyncedFromWeb
            );
        }

        var conflictsToSyncFromDesktop = [];
        var uuidsOfConflictsSyncedFromDesktop = [];
        conflictsToSyncFromDesktop = await sync.getObjectsThatNeedToBeSyncedFromDesktop(
          conflictsKeepDesktop
        );
        // split array into chunks
        conflictsToSyncFromDesktop = sync.chunkArray(
          conflictsToSyncFromDesktop,
          this.arrayChunkSize
        );

        for (const chunkOfConflictsToSyncFromDesktop of conflictsToSyncFromDesktop) {
          const responseUuidsOfConflictsSyncedFromDesktop = await sync.syncValuesInWebDB(
            chunkOfConflictsToSyncFromDesktop,
            this.appId
          );
          if (responseUuidsOfConflictsSyncedFromDesktop)
            uuidsOfConflictsSyncedFromDesktop = uuidsOfConflictsSyncedFromDesktop.concat(
              responseUuidsOfConflictsSyncedFromDesktop
            );
        }

        if (uuidsOfConflictsSyncedFromWeb || uuidsOfConflictsSyncedFromDesktop) {
          const uuidsOfConflictsSynced = uuidsOfConflictsSyncedFromWeb.concat(
            uuidsOfConflictsSyncedFromDesktop
          );
          await sync.deleteRowsFromWebSyncTable(uuidsOfConflictsSynced, this.appId);
          await sync.deleteRowsFromDesktopSyncTable(uuidsOfConflictsSynced);
        }

        // 2. web changes
        // get objects that need to be synced from web
        // sync values in desktop app + then, if success, delete rows from web sync table (by row_uuid + app_id)

        // split array into chunks
        webChanges = sync.chunkArray(webChanges, this.arrayChunkSize);

        for (const chunkOfWebChanges of webChanges) {
          let objectsToSyncFromWeb = [];
          let uuidsOfObjectsSyncedFromWeb = [];

          objectsToSyncFromWeb = await sync.getObjectsThatNeedToBeSyncedFromWeb(chunkOfWebChanges);

          if (objectsToSyncFromWeb)
            uuidsOfObjectsSyncedFromWeb = await sync.syncValuesInDesktopDB(objectsToSyncFromWeb);
          if (uuidsOfObjectsSyncedFromWeb)
            await sync.deleteRowsFromWebSyncTable(uuidsOfObjectsSyncedFromWeb, this.appId);
        }

        // 3. local changes
        // get objects that need to be synced from desktop
        // sync values in web
        //    + add changes in remote sync table for other app ids (done automatically .. eventually, ignore this appId) ???: or delete after ..
        //    + then, if success, delete rows from desktop sync table (by row_uuid)

        let objectsToSyncFromDesktop = [];
        objectsToSyncFromDesktop = await sync.getObjectsThatNeedToBeSyncedFromDesktop(
          desktopChanges
        );

        // split array into chunks
        objectsToSyncFromDesktop = sync.chunkArray(objectsToSyncFromDesktop, this.arrayChunkSize);

        for (const chunkOfObjectsToSyncFromDesktop of objectsToSyncFromDesktop) {
          let uuidsOfObjectsSyncedFromDesktop = [];

          uuidsOfObjectsSyncedFromDesktop = await sync.syncValuesInWebDB(
            chunkOfObjectsToSyncFromDesktop,
            this.appId
          );
          if (uuidsOfObjectsSyncedFromDesktop)
            await sync.deleteRowsFromDesktopSyncTable(uuidsOfObjectsSyncedFromDesktop);
        }

        this.syncingSucceded();

        console.log("Syncing succeded");
      } catch (err) {
        this.syncingFailed();

        console.error("Syncing failed", err);
      }
    },
    hideSyncResultIndicator() {
      setTimeout(() => {
        this.$store.state.showSyncLoadingSuccess = false;
        this.$store.state.showSyncLoadingError = false;
      }, 2000);
    },
    syncingSucceded() {
      this.$store.state.showSyncLoading = false;
      this.$store.state.showSyncLoadingSuccess = true;
      this.hideSyncResultIndicator();
    },
    syncingFailed() {
      this.$store.state.showSyncLoading = false;
      this.$store.state.showSyncLoadingError = true;
      this.hideSyncResultIndicator();
    },
  },
};
